import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { productsApiUrl, fileUrl } from '../constants/endpoints';
import { BsCart3, BsArrowLeft } from 'react-icons/bs';
import { cartService } from '../services/cartService';
import SideCart from '../components/SideCart';
import CartIcon from '../components/CartIcon';

const ProductDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    
    // Check if current language is Arabic
    const isRTL = i18n.language === 'ar';

    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showSideCart, setShowSideCart] = useState(false);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                setLoading(true);
                const response = await fetch(`${productsApiUrl}/public_app/products/${id}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch product');
                }
                const data = await response.json();
                setProduct(data);
            } catch (err) {
                setError(err.message);
                console.error('Error fetching product:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchProduct();
    }, [id]);


    const handleValidateOrder = async () => {
        try {
            // Add product to cart
            await cartService.addToCart(product.id, 1);
            // Get updated cart data
            const cartData = await cartService.getCart();
            // Navigate directly to checkout with cart data
            navigate('/checkout', { state: { cart: cartData } });
        } catch (err) {
            console.error('Error:', err);
        }
    };


    if (loading) {
        return (
            <div className='pd-top-150'>
                <div className='container'>
                    <div className='text-center'>
                        <h3>{t('Loading product...')}</h3>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !product) {
        return (
            <div className='pd-top-150'>
                <div className='container'>
                    <div className='text-center'>
                        <h3>{t('Product not found')}</h3>
                        <button 
                            onClick={() => navigate('/products')}
                            style={{
                                backgroundColor: '#9143DA',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                borderRadius: '8px',
                                marginTop: '20px',
                                cursor: 'pointer'
                            }}
                        >
                            {t('Back to Products')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='pd-top-150' style={{ paddingTop: window.innerWidth <= 768 ? '220px' : '280px'}}>
            {/* Cart Icon - Fixed Position */}
            <CartIcon
                onClick={() => setShowSideCart(true)}
                style={{
                    position: 'fixed',
                    top: window.innerWidth <= 768 ? '120px' : '170px',
                    [isRTL ? 'left' : 'right']: window.innerWidth <= 768 ? '15px' : '20px',
                    zIndex: 998,
                    width: window.innerWidth <= 768 ? '45px' : '50px',
                    height: window.innerWidth <= 768 ? '45px' : '50px'
                }}
            />

            <div className='container'>
                <div className='row mb-4'>
                    <div className='col-12'>
                        <button 
                            onClick={() => navigate('/products')}
                            style={{
                                backgroundColor: 'transparent',
                                border: '1px solid #9143DA',
                                color: '#9143DA',
                                padding: '8px 16px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '14px'
                            }}
                        >
                            <BsArrowLeft /> {t('Back to Products')}
                        </button>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12 mb-4'>
                        <div className='row align-items-start'>
                            {/* Left side - Product Name and Level */}
                            <div className='col-lg-8 col-md-7'>
                                {/* Product Name */}
                                <h1 style={{
                                    fontSize: '28px',
                                    fontWeight: 'bold',
                                    color: '#2c3e50',
                                    marginBottom: '15px',
                                    lineHeight: '1.3'
                                }}>
                                    {product.name}
                                </h1>

                                {/* Academic Info */}
                                {(product.institut_grade || product.institut_speciality) && (
                                    <div style={{ marginBottom: '15px' }}>
                                        <span style={{ color: '#666' }}>
                                            {product.institut_grade}
                                            {product.institut_grade && product.institut_speciality && ' '}
                                            {product.institut_speciality}
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Right side - Price and Actions */}
                            <div className='col-lg-4 col-md-5 text-right'>
                                {/* Price */}
                                <div style={{ marginBottom: '15px' }}>
                                    <div>
                                        <span style={{
                                            fontSize: '24px',
                                            fontWeight: 'bold',
                                            color: product.discount_percentage > 0 ? '#9143DA' : '#2c3e50'
                                        }}>
                                            {product.discount_percentage > 0 
                                                ? parseFloat(product.final_price).toFixed(2) 
                                                : parseFloat(product.price).toFixed(2)
                                            } {t('TND')}
                                        </span>
                                    </div>
                                </div>

                                {/* Continue Shopping */}
                              {/*   <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'flex-end',
                                    marginBottom: '10px',
                                    gap: '10px'
                                }} onClick={handleBackToProducts}>
                                    <span style={{ 
                                        fontSize: '14px', 
                                        color: '#2c3e50',
                                        fontWeight: '500'
                                    }}>
                                        {t('Continue Shopping')}
                                    </span>
                                    <button 
                                        //onClick={handleAddToCart}
                                        //disabled={addingToCart}
                                        onClick={handleBackToProducts}
                                        style={{
                                            width: '35px',
                                            height: '35px',
                                            borderRadius: '50%',
                                            backgroundColor: addedToCart ? '#28a745' : 'transparent',
                                            border: `1px solid ${addedToCart ? '#28a745' : '#ccc'}`,
                                            color: addedToCart ? 'white' : '#666',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: addingToCart ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {addingToCart ? (
                                            <div style={{ 
                                                width: '16px', 
                                                height: '16px', 
                                                border: '2px solid #666',
                                                borderTop: '2px solid transparent',
                                                borderRadius: '50%',
                                                animation: 'spin 1s linear infinite'
                                            }} />
                                        ) : addedToCart ? (
                                            <BsCheck size={16} />
                                        ) : (
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
                                            </svg>
                                        )}
                                    </button>
                                </div> */}

                                {/* Validate Order */}
                                <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'flex-end',
                                    gap: '10px'
                                }}>
                                    <span style={{ 
                                        fontSize: '14px', 
                                        color: '#2c3e50',
                                        fontWeight: '500'
                                    }}>
                                        {t('Validate Order')}
                                    </span>
                                    <button 
                                        onClick={handleValidateOrder}
                                        style={{
                                            width: '35px',
                                            height: '35px',
                                            borderRadius: '50%',
                                            backgroundColor: 'transparent',
                                            border: '1px solid #ccc',
                                            color: '#666',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.borderColor = '#9143DA';
                                            e.target.style.color = '#9143DA';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.borderColor = '#ccc';
                                            e.target.style.color = '#666';
                                        }}
                                    >
                                        <BsCart3 size={16} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Product Images - Second Row */}
                    <div className='col-12'>
                        {product.images && product.images.length > 0 ? (
                            <div style={{
                                backgroundColor: '#fff',
                                borderRadius: '15px',
                                padding: '20px',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                            }}>
                                <div className='row'>
                                    {product.images.slice(0, 3).map((image, index) => (
                                        <div key={index} className='col-lg-4 col-md-4 col-sm-4'>
                                            <img
                                                src={`${fileUrl}/${image.image_id}`}
                                                alt={`${product.name} ${index + 1}`}
                                                style={{
                                                    width: '100%',
                                                    height: '400px',
                                                    objectFit: 'contain',
                                                    borderRadius: '10px'
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div style={{
                                width: '100%',
                                height: '300px',
                                backgroundColor: '#f8f9fa',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '15px',
                                color: '#6c757d',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
                            }}>
                                <span>{t('No Images Available')}</span>
                            </div>
                        )}
                    </div>

                    {/* Product Description and Content - Third Row */}
                    <div className='col-12 mt-4'>
                        <div className='row'>
                            {/* Description */}
                            <div className='col-lg-8 col-md-7'>
                                <div style={{ marginBottom: '30px' }}>
                                    <h3 style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#2c3e50',
                                        marginBottom: '15px'
                                    }}>
                                        {t('Description')}
                                    </h3>
                                    <p style={{
                                        fontSize: '16px',
                                        lineHeight: '1.6',
                                        color: '#666',
                                        textAlign: 'justify'
                                    }}>
                                        {product.description}
                                    </p>
                                </div>
                            </div>
                            
                            {/* Content */}
                            <div className='col-lg-4 col-md-5'>
                                <div style={{ marginBottom: '30px' }}>
                                    <h3 style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#2c3e50',
                                        marginBottom: '15px'
                                    }}>
                                        {t('Content')}
                                    </h3>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{
                                                width: '20px',
                                                height: '20px',
                                                backgroundColor: '#28a745',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
                                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                                                </svg>
                                            </div>
                                            <span style={{ color: '#666', fontSize: '14px' }}>{t('Course Summary')}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{
                                                width: '20px',
                                                height: '20px',
                                                backgroundColor: '#28a745',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
                                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                                                </svg>
                                            </div>
                                            <span style={{ color: '#666', fontSize: '14px' }}>{t('Exercises')}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{
                                                width: '20px',
                                                height: '20px',
                                                backgroundColor: '#28a745',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
                                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                                                </svg>
                                            </div>
                                            <span style={{ color: '#666', fontSize: '14px' }}>{t('Corrected Series')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Side Cart */}
                <SideCart 
                    isOpen={showSideCart}
                    onClose={() => setShowSideCart(false)}
                    autoCloseDelay={0} // Don't auto-close when opened via cart icon
                />

                {/* Order Modal */}

                {/* Add keyframes for loading spinner */}
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
            </div>
        </div>
    );
};

export default ProductDetailPage;
